import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { LocaleInterface } from 'types'

/**
 * Non-rendering component that sets window title from props
 * Requires locale from context
 */
const WindowTitle: React.FC<WindowTitleProps> = ({ children, locale }) => {
  const location = useLocation()

  useEffect(() => {
    const titleKey = `title.${location.pathname}`
    let title: string = locale.translate('title.base')
    if (children) {
      title = `${children} | ${title}`
    }
    if (locale.hasTranslation(titleKey)) {
      title = locale.translate(titleKey) + (children ? ' : ' : ' | ') + title
    }
    window.document.title = title
  }, [children, locale, location.pathname])

  return null
}

type WindowTitleProps = {
  locale: LocaleInterface
  children?: string
}

export default WindowTitle
